"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unselectedStrokeStrongYesOrNoColor = exports.unselectedStrokeColor = exports.unselectedFillColor = exports.defaultArrowProps = void 0;
var _constants = require("../constants");
var unselectedStrokeColor = exports.unselectedStrokeColor = '#bebebe';
var unselectedFillColor = exports.unselectedFillColor = _constants.colors.lighterGrey;
var unselectedStrokeStrongYesOrNoColor = exports.unselectedStrokeStrongYesOrNoColor = '#d7d7d';
var defaultArrowProps = exports.defaultArrowProps = {
  width: 20,
  strokeWidth: 1,
  color: _constants.colors.darkGrey
};